import { render } from "./App.vue?vue&type=template&id=b383d3a0"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=b383d3a0&lang=scss"

import exportComponent from "/home/runner/work/project-booster--collaborator/project-booster--collaborator/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__